import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import ItemService from "../../../../services/supplier_appCommonService";
import { InputField } from "../../../formElements/InputField";
import { TextAreaField } from "../../../formElements/TextAreaField";
import FileUploadComponent from "../../../formElements/FileUploadComponent";
import FileViewerModal from "../../../FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";

const CatalogEditMaterialModal = React.forwardRef((props, ref) => {
  // const dispatch = useDispatch();
  const [formInputs, setFormInputs] = useState({
    productName: "",
    category: "",
    subCategory: "",
    description: "",
    vendor: "",
    vendorLocation: "",
    warranty: "",
    returnPolicy: "",
    availability: "In Stock",
    price: "",
    weight: "N/A",
    dimensions: "N/A",
    color: "N/A",
    material: "N/A",
    careInstructions: "N/A",
  });
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [disabled, setDisabled] = useState();
  const [isEditMode, setIsEditMode] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  let tenderNr = useSelector(
    (state) => state?.purchasing?.catalogData?.catalogNr,
  );

  // const handleUpdate = async () => {
  //   const {
  //     createdAt,
  //     updatedAt,
  //     submittedAt,
  //     createdBy,
  //     submittedBy,
  //     catalogStatus,
  //     documentNumber,
  //     timeZone,
  //     ...editableFields
  //   } = formInputs;

  //   const payload = {
  //     catalogNr: tenderNr,
  //     data: editableFields,
  //   };

  //   console.log("FINAL UPDATE PAYLOAD 👉", payload);

  //   // const toastId = toast.loading("Saving...", { position: "top-right" });
  //   setDisabled(true);

  //   try {
  //     const item = await ItemService.updateCatalog(payload);

  //     if (item?.status === 200) {
  //       toast.success("Catalog updated successfully", {
  //         position: "top-right",
  //       });
  //       setIsEditMode(false);
  //       // props.onHide();
  //       props.onSuccess(); // 🔥 refresh list
  //       props.onHide(); // 🔥 close modal
  //     } else {
  //       toast.error("Update failed");
  //     }
  //   } catch (error) {
  //     toast.error("Update failed");
  //   } finally {
  //     // toast.dismiss(toastId);
  //     setDisabled(false);
  //   }
  // };

  const handleUpdate = async () => {
  const {
    createdAt,
    updatedAt,
    submittedAt,
    createdBy,
    submittedBy,
    catalogStatus,
    documentNumber,
    timeZone,
    ...editableFields
  } = formInputs;

  const payload = {
    catalogNr: tenderNr,
    data: editableFields,
  };

  console.log("FINAL UPDATE PAYLOAD 👉", payload);

  setDisabled(true);

  try {
    const item = await ItemService.updateCatalog(payload);

    if (item?.status === 200) {
      toast.success("Catalog updated successfully", {
        position: "top-right",
      });

      setIsEditMode(false);
      props.onSuccess();
      props.onHide();
    } else {
      toast.error("Update failed");
    }
  } catch (error) {
    toast.error("Update failed");
  } finally {
    setDisabled(false);
  }
};
  console.log(tenderNr);

  // const loadInitialPageData = async () => {
  //   if (!tenderNr || isLoading) return;

  //   setIsLoading(true);
  //   const toastId = toast.loading("Loading...", { position: "top-right" });

  //   try {
  //     const item = await ItemService.generateQueryV1({
  //       queryName: "GET_Catalog_Detail",
  //       documentNumber: tenderNr,
  //     });

  //     if (item?.status === 200) {
  //       setFormInputs(item.data[0]);
  //     } else {
  //       toast.error("Failed to load catalog");
  //     }
  //   } finally {
  //     toast.dismiss(toastId);
  //     setIsLoading(false);
  //   }
  // };

  const loadInitialPageData = async () => {
  if (!tenderNr || isLoading) return;

  setIsLoading(true);
  const toastId = toast.loading("Loading...", { position: "top-right" });

  try {
    const item = await ItemService.generateQueryV1({
      queryName: "GET_Catalog_Detail",
      documentNumber: tenderNr,
    });

    if (item?.status === 200) {
      // 🔥 Fix nested data issue
      setFormInputs(item.data[0]?.data || item.data[0]);
    } else {
      toast.error("Failed to load catalog");
    }
  } finally {
    toast.dismiss(toastId);
    setIsLoading(false);
  }
};

  useEffect(() => {
    if (props.show && tenderNr) {
      loadInitialPageData();
      setIsEditMode(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show, tenderNr]);

  useEffect(() => {
    // console.log(">> props?.dropdownData", props?.dropdownData);
    // setDropdownOption(props?.dropdownData);

    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };
  const [isCardVisible1, setCardVisible1] = useState(true);
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {/* <i className="bi bi-plus-lg"></i>  */}
          Material Details
        </Modal.Title>
      </Modal.Header>
      {!isEditMode && (
        <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
          <button
            type="button"
            // onClick={handleUpdate}
            onClick={() => setIsEditMode(true)}
            disabled={disabled}
            className="btn btn-primary mt-4 w-full justify-center rounded-md"
          >
            Update
          </button>
        </Col>
      )}

      <Modal.Body className="">
        {/* accordin1 */}
        <Col xs={8} md={2} lg={2} className="commLeftRightPadding">
          {(formInputs?.billDocument && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(formInputs?.billDocument)}
            />
          )) ||
            "--"}
        </Col>
        <Col xs={12} md={12} lg={4} className="commLeftRightPadding">
          <FileUploadComponent
            id="imageUrl"
            name="imageUrl"
            label="Product Image"
            allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
            multiple={true} // Change to false for single file selection
            required={true}
            onSuccessUpload={onSuccessUploadDocumentType}
            value={formInputs?.imageUrl || ""}
          />
        </Col>
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-down" : "bi-chevron-right"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PI</span>
                </Col>
                <Col xs={8} md={9} lg={9}>
                  <span className="headerTitle">Product Information</span>
                  <span className="subHeaderTitle">Product Infromation</span>
                </Col>
              </Row>
            </h2>

            <div
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row className="pt-2 pb-4 d-flex align-items-center">
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <InputField
                      placeholder=""
                      className="inputBox"
                      label="Product Name"
                      id="productName"
                      name="productName"
                      type="text"
                      value={formInputs?.productName || ""}
                      onChange={onInputChange}
                      disabled={!isEditMode}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <InputField
                      placeholder=""
                      className="inputBox"
                      label="Category"
                      id="category"
                      name="category"
                      type="text"
                      value={formInputs?.category || ""}
                      onChange={onInputChange}
                      disabled={!isEditMode}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <InputField
                      placeholder=""
                      className="inputBox"
                      label="Sub Category"
                      id="subCategory"
                      name="subCategory"
                      type="text"
                      value={formInputs?.subCategory || ""}
                      onChange={onInputChange}
                      disabled={!isEditMode}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <InputField
                      placeholder=""
                      className="inputBox"
                      label="Price"
                      id="price"
                      name="price"
                      type="number"
                      value={formInputs?.price || ""}
                      onChange={onInputChange}
                      disabled={!isEditMode}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <InputField
                      placeholder=""
                      className="inputBox"
                      label="Description"
                      id="description"
                      name="description"
                      type="text"
                      value={formInputs?.description || ""}
                      onChange={onInputChange}
                      disabled={!isEditMode}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <InputField
                      placeholder=""
                      className="inputBox"
                      label="Warranty"
                      id="warranty"
                      name="warranty"
                      type="text"
                      value={formInputs?.warranty || ""}
                      onChange={onInputChange}
                      disabled={!isEditMode}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <InputField
                      placeholder=""
                      className="inputBox"
                      label="Vendor"
                      id="vendor"
                      name="vendor"
                      type="text"
                      value={formInputs?.vendor || ""}
                      onChange={onInputChange}
                      disabled={!isEditMode}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <TextAreaField
                      placeholder=""
                      className="inputBox"
                      label="Vendor Address"
                      id="vendorLocation"
                      name="vendorLocation"
                      type="text"
                      value={formInputs?.vendorLocation || ""}
                      onChange={onInputChange}
                      disabled={!isEditMode}
                    />
                  </Col>
                  <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
                    <TextAreaField
                      placeholder=""
                      className="inputBox"
                      label="Return Policy"
                      id="returnPolicy"
                      name="returnPolicy"
                      type="text"
                      value={formInputs?.returnPolicy || ""}
                      onChange={onInputChange}
                      disabled={!isEditMode}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <form className="space-y-4">
          <Row className="justify-end">
            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                // onClick={() => props.onHide()}
                onClick={() => {
                  setIsEditMode(false);
                  loadInitialPageData(); // reset changes
                  props.onHide();
                }}
                className="btn btn-danger mt-4 w-full justify-center rounded-md"
              >
                Cancel
              </button>
            </Col>

            <Col xs={6} md={3} lg={3} className="commLeftRightPadding">
              <button
                type="button"
                onClick={handleUpdate}
                disabled={disabled}
                className="btn btn-primary mt-4 w-full justify-center rounded-md"
              >
                Save
              </button>
            </Col>
            <Col xs={12} md={12} lg={12} className="commLeftRightPadding">
              {/* <p className="errorMsg"> {errorMsg} </p> */}
            </Col>
          </Row>
        </form>
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
      </Modal.Body>
    </Modal>
  );
});

export default CatalogEditMaterialModal;
